<div
    class="media-tag d-flex align-items-center"
    [ngClass]="
        fill() === 'outline'
            ? [mediaTypeBorder(), mediaTypeText(), fill(), font()]
            : fill() === 'filled'
              ? [mediaTypeFilled(), mediaTypeBorder(), font()]
              : [font()]
    "
>
    <i
        class="pe-1"
        [ngClass]="
            fill() === 'filled'
                ? [mediaTypeFilled(), mediaTypeIcon()]
                : [mediaTypeIcon(), mediaTypeText()]
        "
    ></i>
    {{ media() | titlecase }}
</div>
